export default __webpack_public_path__ + "static/media/coach_guideme_softclix_lancingkit_lancets200_strips250_scale_cuff_gray@1x.b1a62ba5.jpg";